const notifications = {
  position: 'top-right',
  duration: 2500,
  labels: {
    success: 'Sucesso',
    warning: 'Atenção',
    alert: 'Atenção',
    confirm: 'Confirmação',
    info: 'Informação',
  },
}

export { notifications as default }
